import type { ApolloError } from 'apollo-client';
import type { GraphQLError } from 'graphql';

const IGNORED_ERRORS = [
	{ errorType: 'ISSUE_UNAVAILABLE', statusCode: 404 },
	{ errorType: 'FIELD_VALUE_UNAVAILABLE', statusCode: 500 },
	{ errorType: 'DATA_FETCHER_THREW', statusCode: 500 },
];

export const shouldHandleTheError = (error?: ApolloError) => {
	if (error?.networkError) {
		return true;
	}

	const filterIssueUnavailableErrors = (graphQLError?: GraphQLError) =>
		!IGNORED_ERRORS.find(
			(ignoredError) =>
				ignoredError.errorType === graphQLError?.extensions?.errorType &&
				ignoredError.statusCode === graphQLError?.extensions?.statusCode,
		);

	const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueUnavailableErrors);

	return errorsToShow.length > 0;
};
